/* eslint-disable */
import StarsBanner from "~/ui/stars-banner";
import { IReviewData, IReviewUser } from "./interfaces";
import POIListItem from "~/ui/poilistitem";
import createSDSIcon from "~/ui/icon";
import { OVERFLOW_MENU_VERTICAL_FILLED_24, TIME_ALT1_24, CHEVRON_DOWN_24, CHEVRON_UP_24 } from "@sznds/icons";
import MyMapsContextMenu from "~/es6/mymaps.contextmenu";
import { node, icon } from "~/util/dom";
import FirmReviewEdit from "~/review/edit";
import FirmReviewRemove from "~/review/remove";
import FirmReviewReport from "~/review/report";
import { loadClamp } from "~/es6/clamp-loader";
import FirmLike from "~/review/like";
import { IReview, IReviewItem } from "~/review/interfaces";
import { putToCache } from "~/util/reviews-cache";
import { store } from "~/state/store";
import { deferPromise } from "~/util/general";
import { ONE_YEAR } from "~/util/constants";
import { LOG_SOURCE } from "./constants";
import { isFirmFromReview, isTwin, clamp, getFirmImpressConfig, getReviewConf, hasFilledStructuredReviews } from "~/util/review";
import { createReviewPhotos } from "~/ui/review/photos";
import { createEmojisPreview } from "~/ui/review/emojisPreview";
import { IDeferPromise } from "~/interfaces";
import { getDetail, IGetDetailOutput } from "~/util/providers/review";
import { CONFIG } from "~/config";
import { dateFormat } from "~/util/format";
import { _ } from "~/i18n";
import { isDetailActive } from "~/util/detail";
import { createDeepLTranslate, IReviewDeepLData } from "~/ui/deepl/review";

interface IReviewItemOptions {
	data: IReviewData;
	user: IReviewUser;
	onEdit?: Function;
	onDelete?: Function;
	index: number;
	isCurrentUser: boolean;
	update?: boolean;
	analytics: {
		[key: string]: string|number|boolean;
	};
	onEnter?: () => void;
	onLeave?: () => void;
}

export default class MyReview {
	_container: HTMLLIElement;
	_top: HTMLElement;
	_data: IReviewData;
	_user: IReviewUser;
	_contextMenu: MyMapsContextMenu;
	_onEdit: Function;
	_onDelete: Function;
	_edit: FirmReviewEdit;
	_replyButton: HTMLButtonElement;
	_replyCont: HTMLDivElement;
	_firmImpressWasSend: boolean;
	_clampIsShortened: boolean;
	_firstClampPromiseData: IDeferPromise<any>;
	_index: number;
	_analytics: {
		[key: string]: string|number|boolean;
	};
	_detailData: IGetDetailOutput;
	_onEnter: () => void;
	_onLeave: () => void;

	constructor({ data, user, onDelete, onEdit, isCurrentUser, update = false, analytics = {}, index = 1, onEnter, onLeave }: IReviewItemOptions) {
		this._container = node("li", { className: "myreview" });
		this._top = null;
		this._edit = null;
		this._data = data;
		this._user = user;
		this._onDelete = onDelete;
		this._onEdit = onEdit;
		this._contextMenu = null;
		this._firmImpressWasSend = false;
		this._clampIsShortened = false;
		this._firstClampPromiseData = deferPromise();
		this._index = index;
		this._analytics = analytics;
		this._detailData = null;
		this._onEnter = onEnter;
		this._onLeave = onLeave;

		this._build(isCurrentUser, update);
	}

	destroy() {
		this._replyButton.removeEventListener("click", this);
	}

	get node() {
		return this._container;
	}

	get header() {
		return this._top;
	}

	set index(value) {
		this._index = value;
	}

	handleEvent() {
		this._replyButton.classList.toggle("visible");
		this._replyCont.classList.toggle("visible");

		Mapy.getComponent("logger").log("click", {
			text: this._replyButton.classList.contains("visible") ? "ownerReactionShow" : "ownerReactionHide",
			...this._analytics,
		});
	}

	firmImpressAnalytics() {
		if (this._firmImpressWasSend) return true;

		this._firmImpressAnalytics();

		this._firmImpressWasSend = true;

		return false;
	}

	_firmImpressAnalytics(reviewShowMoreAction = false) {
		this._firstClampPromiseData.promise.then(() => {
			const config = getFirmImpressConfig({
				reviewId: this._data.id,
				state: this._data.state,
				reviewOrder: this._index,
				reviewShortened: reviewShowMoreAction || this._clampIsShortened,
				reviewAuthor: false,
				reviewShowMoreAction,
			});

			Mapy.getComponent("logger").log(config.action, {
				...config.data,
				...this._analytics,
			});
		}, () => {});
	}

	_build(isCurrentUser, update) {
		const { user } = store.getState().user;
		// cast s infem o POIi
		const premise = new POIListItem({
			data: this._data.description,
			onClick: () => {
				Mapy.getComponent("logger").log("click", {
					text: isCurrentUser ? "dashboardGoToDetail" : "publicProfileGoToDetail",
					...isCurrentUser ? {} : { publicProfile: "1" },
				});
				// pokud mame aktivni detail schovany pod aktualnim overlayem, tak ho pozdeji nahodime nahoru
				const detailActive = isDetailActive(store.getState());

				Mapy.getComponent("detail").setState({
					source: this._data.detail_poi.source,
					id: this._data.detail_poi.id,
					backTitle: _("mymap.switcher.reviews"),
				}).then(() => {
					detailActive && Mapy.getComponent("detail").show();
					Mapy.getComponent("history").save();
				}, () => {});
			},
		});
		this._container.appendChild(premise.node);

		const top = node("div", { className: "myreview__top" });
		const rating = new StarsBanner({
			percentage: this._data.rating,
		});
		let menuButtonSet = false;
		const menuButton = node("button", { type: "button", className: "myreview__topbutton" });
		menuButton.appendChild(createSDSIcon({
			symbol: OVERFLOW_MENU_VERTICAL_FILLED_24,
		}));
		menuButton.setAttribute("data-log-ignore", "1");
		top.appendChild(rating.container);

		const reviewDate = new Date(this._data.updated);
		const time = node("h2", { innerHTML: new Intl.DateTimeFormat(CONFIG.defaultLang, { year: "numeric", month: "long", day: "numeric" }).format(reviewDate) + (reviewDate.getTime() + ONE_YEAR < new Date().getTime() ? ` (${_("mymap.reviews.aYearAgo")})` : "") });

		top.appendChild(time);
		update && this._container.classList.add("myreview--update");

		if (this._data.state === "waiting") {
			top.appendChild(createSDSIcon({
				symbol: TIME_ALT1_24,
				title: _("mymap.reviews.approvalPending"),
			}));
		}

		if (isCurrentUser) {
			if (!this._data.description.inactive) {
				menuButtonSet = true;
				menuButton.addEventListener("click", () => {
					Mapy.getComponent("logger").log("click", {
						text: "contextMenu",
						...this._analytics,
						type: update ? "recenze-update" : "recenze-edit",
						...update
							? {
								signal: `${this._data.description.typeId}_${this._data.description.id}`,
							}
							: {
								refused: this._data?.state === "rejected" ? 1 : 0,
							},
					});

					if (!this._contextMenu) {
						let names = [];

						if (this._data?.state == "rejected") {
							names = [
								...this._data?.enableEdit === true ? ["edit"] : [],
								"delete",
							];
						} else {
							names = [
								update ? "update" : "edit",
								"delete",
							];
						}

						this._contextMenu = new MyMapsContextMenu({
							clickCb: action => this._contextMenuAction(action),
							names,
						});

						this._contextMenu.parent = top;
					}

					this._contextMenu.toggle();
				});
			}
		} else {
			const { type, ...analytics } = this._analytics;

			menuButtonSet = true;
			menuButton.addEventListener("click", () => {
				Mapy.getComponent("logger").log("click", {
					text: "contextMenu",
					...analytics,
				});

				if (!this._contextMenu) {
					this._contextMenu = new MyMapsContextMenu({
						clickCb: action => this._contextMenuAction(action),
						names: [
							"report",
						],
					});

					this._contextMenu.parent = top;
				}

				this._contextMenu.toggle();
			});
		}

		menuButtonSet && top.appendChild(menuButton);

		this._container.appendChild(top);
		this._top = top;

		if (this._data.text) {
			const text = node("p", { className: "myreview__text" }, this._data.text);

			this._container.appendChild(text);
			loadClamp().then(() => {
				setTimeout(() => {
					this._clampIsShortened = clamp(text, true, () => {
						this._firmImpressAnalytics(true);
					});
					this._firstClampPromiseData.resolve({});
				}, 0);
			}, () => {});

			let textToTranslation: IReviewDeepLData = {
				text: this._data.text,
				lang: this._data.lang,
				container: text,
				reviewId: this._data.id,
				type: "text",
				native: this._data.native || !("native" in this._data),
			};

			if (textToTranslation && this._data.user?.public_id !== user.userPublicId) {
				const deepl = createDeepLTranslate(textToTranslation, "review");

				deepl && this._container.appendChild(deepl);
			}
		} else {
			this._firstClampPromiseData.resolve({});
		}

		// strukturovane hodnoceni
		this._container.append(
			createEmojisPreview({
				config: this._data.structured_rating || [],
			}).container,
		);

		// fotky
		const hasPhotos = this._hasPhotos();

		hasPhotos && this._container.appendChild(createReviewPhotos({
			reviewData: {
				...this._data,
				user: this._user,
			},
		}));

		const likeReplyCont = node("div", { className: "myreview--like-reply" });

		this._container.appendChild(likeReplyCont);

		// libi se
		if (this._data.text || hasPhotos) {
			const likes = new FirmLike({
				id: this._data.likes ? this._data.likes.id : `review.firm.${this._data.id}`,
				data: this._data.likes,
				disabled: isCurrentUser,
				index: this._index + 1,
				detail: {
					source: this._data.review_poi.source,
					id: this._data.review_poi.id as number,
					typeId: this._data.description.typeId,
				},
				analytics: {
					publicProfile: "1",
				},
			});
			likeReplyCont.append(likes.container);
		}

		// reakce vlastnika
		this._replyButton = node("button", { type: "button", className: "myreview--toggle", innerHTML: _("detail.content.review2.reaction") });
		this._replyButton.appendChild(createSDSIcon({ symbol: CHEVRON_DOWN_24, className: "chevron-down" }));
		this._replyButton.appendChild(createSDSIcon({ symbol: CHEVRON_UP_24, className: "chevron-up" }));
		this._replyButton.addEventListener("click", this);
		this._replyButton.setAttribute("data-log-ignore", "1");

		this._buildReply(likeReplyCont);

		if (this._data?.state == "rejected") {
			const rejectedCont = node("div", { className: "myreview--rejected-cont" });
			const msg = node("p", { textContent: this._data?.rejectReason || "" });
			const buttons = node("div", { className: "rejected-buttons" });

			if (this._data?.enableEdit === true) {
				const editTextBtn = node("button", { className: "edit-text-btn", textContent: _("edit") });

				editTextBtn.addEventListener("click", () => {
					this._contextMenuAction("edit");
				});
				buttons.append(editTextBtn);
			}

			const removeReviewBtn = node("button", { className: "remove-review-btn", textContent: _("detail.content.review2.removeReview") });

			removeReviewBtn.addEventListener("click", () => {
				this._contextMenuAction("delete");
			});
			buttons.append(removeReviewBtn);
			rejectedCont.append(msg, buttons);

			this._container.appendChild(rejectedCont);
		}

		// udalosti on enter/leave
		this._onEnter && this._container.addEventListener("pointerenter", () => this._onEnter());
		this._onLeave && this._container.addEventListener("pointerleave", () => this._onLeave());
	}

	_buildReply(likeReplyCont: HTMLDivElement) {
		const data = this._data?.reply;

		if (!data) {
			return;
		}

		const replyCont = node("div", { className: "myreview--reply" });
		const leftPart = node("span", { className: "left-part" });
		const rightPart = node("span", { className: "right-part" });

		leftPart.appendChild(icon("reply"));

		const caption = node("h2", { className: "reply-title", textContent: _("detail.content.review2.reaction") });
		const replyDesc = node("p", { textContent: Mapy.Util.escapeHTML(data.text) });
		// datum
		const date = node("span", { className: `date`, textContent: dateFormat(new Date(data.updated), "d. mn yyyy") });

		rightPart.appendChild(caption);
		rightPart.appendChild(replyDesc);
		caption.appendChild(date);
		replyCont.appendChild(leftPart);
		replyCont.appendChild(rightPart);

		this._container.append(replyCont);
		likeReplyCont.append(this._replyButton);
		this._replyCont = replyCont;
		// orezeme
		loadClamp().then(() => {
			clamp(replyDesc, true);
		}, () => { /**/ });
	}

	_getMyReview() {
		// zkopirujeme data, nastavime actual
		const shallowCopy = {
			...this._data,
			actual: true,
		};

		["description", "detail_poi", "premise", "review_poi"].forEach(key => key in shallowCopy && delete shallowCopy[key]);

		return JSON.parse(JSON.stringify(shallowCopy));
	}

	_contextMenuAction(action: string) {
		switch (action) {
			case "delete":
				this._openRemovePopup();
				break;

			case "edit":
			case "update":
				this._openEdit(action);
				break;

			case "report":
				const isFirmTwin = isTwin(this._data.description);

				Mapy.getComponent("logger").log("click", {
					text: "Nahlasit problem",
					source: this._analytics.source,
					publicProfile: 1,
					sourcePoi: this._data.description.source,
					typeid: this._data.description.typeId,
					firmTwin: isFirmTwin ? 1 : 0,
					section: "reviews",
				});

				let promise = Promise.resolve();
				const { user } = store.getState().user;

				if (user.state !== "green") {
					promise = Mapy.getComponent("login").open({
						analyticsData: {
							loginOrigin: "reviewsReport",
							section: "reviews",
							publicProfile: 1,
						},
						motivation: "report",
					});
				}

				promise.then(() => {
					new FirmReviewReport({
						id: this._data.id,
						isFirm: isFirmFromReview(this._data),
						isTwin: isFirmTwin,
						isOwner: false,
						logSource: LOG_SOURCE,
						hasPhotos: this._hasPhotos(),
						analytics: {
							source: this._analytics.source,
							publicProfile: 1,
							sourcePoi: this._data.description.source,
							typeid: this._data.description.typeId,
							firmTwin: isFirmTwin ? 1 : 0,
						},
					});
				}, () => {});
				break;
		}
	}

	_hasPhotos() {
		return Array.isArray(this._data.gallery) && this._data.gallery.length > 0;
	}

	_closeEdit() {
		if (this._edit) {
			this._edit.destroy();
			this._edit = null;
		}
	}

	async _getDetailData() {
		if (!this._detailData) {
			this._detailData = await getDetail({ source: this._data.review_poi.source, id: this._data.review_poi.id });
		}

		return this._detailData;
	}

	async _openRemovePopup() {
		try {
			const detailData = await this._getDetailData();
			const myReview = detailData.myReview || this._getMyReview();

			Mapy.getComponent("logger").log("click", {
				text: "Smazat",
				...this._analytics,
			});

			new FirmReviewRemove({
				data: {
					...getReviewConf(detailData.poi),
					title: this._data.description.titleVars.titleSmartMain,
					myReview,
				},
				logSource: LOG_SOURCE,
				analytics: {
					...this._analytics,
					photos: this._hasPhotos() ? 1 : 0,
					attributes: hasFilledStructuredReviews(this._data.structured_rating),
				},
				myReview,
				onDelete: () => this._onDelete && this._onDelete(this._data),
				selectedReasonIndex: this._data?.state === "rejected" ? 1 : 0,
			});
		} catch (exc) {
			console.log(exc);
		}
	}

	async _openEdit(action: string) {
		try {
			const detailData = await this._getDetailData();
			const myReview = detailData.myReview || this._getMyReview();

			Mapy.getComponent("logger").log("click", {
				text: action === "edit" ? "Upravit" : "Aktualizovat hodnocení",
				...this._analytics,
				type: action === "edit" ? "recenze-edit" : "recenze-update",
				...action === "update"
					? {
						signal: `${this._data.description.typeId}_${this._data.description.id}`,
					}
					: {
						refused: this._data?.state === "rejected" ? 1 : 0,
					},
			});

			this._edit = new FirmReviewEdit({
				data: {
					...getReviewConf(detailData.poi),
					title: this._data.description.titleVars.titleSmartMain,
					myReview,
				},
				logSource: LOG_SOURCE,
				analytics: {
					...this._analytics,
					type: action === "edit" ? "recenze-edit" : "recenze-update",
					...action === "update"
						? {
							signal: `${this._data.description.typeId}_${this._data.description.id}`,
						}
						: {
							refused: this._data?.state === "rejected" ? 1 : 0,
						},
				},
				thankYouCont: this._container,
				update: action === "update",
				onSave: ({
					myReview,
				}: {
					review: IReview,
					myReview: IReviewItem,
				}) => {
					putToCache(this._data.description, myReview);
					this._closeEdit();
					this._onEdit && this._onEdit();
				},
				onCancel: () => {
					this._closeEdit();
				}
			});

			this._edit.openEdit();
		} catch (exc) {
			console.log(exc);
		}
	}
}
